import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-614ffaa6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Deixe um feedback avaliando esta aula:", -1))
const _hoisted_2 = { class: "stars" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StarInput = _resolveComponent("StarInput")!
  const _component_TextareaInput = _resolveComponent("TextareaInput")!
  const _component_GradientButton = _resolveComponent("GradientButton")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (star) => {
        return _createVNode(_component_StarInput, {
          key: star,
          id: 'star' + star,
          name: "star",
          value: star,
          modelValue: _ctx.stars,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.stars) = $event))
        }, null, 8, ["id", "value", "modelValue"])
      }), 64))
    ]),
    _createVNode(_component_TextareaInput, {
      modelValue: _ctx.message,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.message) = $event)),
      id: "rating",
      required: _ctx.stars < 4,
      placeholder: "Deixe seu comentário aqui"
    }, null, 8, ["modelValue", "required"]),
    _createVNode(_component_GradientButton, { title: "Enviar avaliação" })
  ], 32))
}